<template>
    <div class="sustainability-has">

        <p class="indent">Наш основен приоритет е здравето и безопасността на всяко лице, намиращо се на територията на Алкомет. Не допускаме компромиси, когато става въпрос за опазване на човешки живот и предпазване от наранявания. За всяко работно място се изготвя и редовно актуализира детайлна оценка на риска с особено внимание върху потенциалните опасности и мерките за избягването им. Всички служители на компанията и външни лица преминават периодичен инструктаж за повишаване тяхната информираност относно разпоредбите за безопасност, изготвени от Алкомет. Използваме най-новите инженерни решения, технологии и добри практики, за да гарантираме най-добрата защита на хората, работещи на територията на компанията.</p>
        <p class="indent">В случай на инцидент се провежда вътрешно разследване за установяване на причините и елиминиране на риска от повтарянето му.</p>
        <p class="indent">Фирмената политика по Здравословни и безопасни условия на труд се основава на сертификат ISO 45001:2018, който компанията притежава от 2019 г.</p>
        <p>
          <a href="/static/files/A-POLICY-FOR-HEALTHY-AND-SAFE-LABOUR-CONDITIONS.pdf" target="_blank">Политика ЗБУТ</a>
          <br>
          <a href="/static/files/Авариен-план-2026.pdf" target="_blank">АВАРИЕН ПЛАН</a>
        </p>
        <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};
</script>

<style scoped>
.sustainability-has > p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
a {
  text-decoration: underline;
}
@media screen and (max-width: 1000px) {
  .sustainability-has {
    padding-bottom: 20px;
  }
  .sustainability-has > p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sustainability/HealthAndSafety.vue